<template>
  <div class="image-list">
    <span v-for="(item, index) in list" :key="index">
      <img
        v-if="fileType(item) === 'img'"
        :src="item"
        class="image-item"
        v-viewer="{ movable: false }"
        @click.stop
      />
      <img
        v-if="fileType(item) === 'pdf'"
        src="../assets/img/pdf.png"
        class="image-item"
        @click.stop="linkFile(item)"
      />
      <img
        v-if="fileType(item) === 'excel'"
        src="../assets/img/excel.png"
        class="image-item"
        @click.stop="linkFile(item)"
      />
      <img
        v-if="fileType(item) === 'word'"
        src="../assets/img/word.png"
        class="image-item"
        @click.stop="linkFile(item)"
      />
    </span>
  </div>
</template>

<script>
import { fileType } from "@/minixs.js";
export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  mixins: [fileType],
  data() {
    return {};
  },
  methods: {
    // 查看附件
    linkFile(url) {
      window.open(url, "_blank");
    },
  },
};
</script>

<style lang="less" scoped>
.image-list {
  display: flex;
  .image-item {
    width: 40px;
    height: 40px;
    margin-right: 5px;
    cursor: pointer;
  }
}
</style>
